import { apiPost } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';

interface ImpersonateWorkspaceParams {
  escritorioId: string;
  motivo?: string;
}

interface ImpersonateWorkspaceResponse {
  escritorioId: string;
  escritorioNome: string;
}

export const adminImpersonateService = {
  async workspace(params: ImpersonateWorkspaceParams): Promise<ImpersonateWorkspaceResponse> {
    const response = await apiPost('/admin/impersonate/workspace', params);
    return parseApiResponse<ImpersonateWorkspaceResponse>(response);
  },
};
